import * as remoteAction from "../remoteAction";

export type AccountCreditReverseActionSuccess =
  remoteAction.MerchantRemoteResponse<"ACCOUNT_CREDIT_REVERSE_SUCCESS", any>;
export type AccountCreditReverseActionFailure =
  remoteAction.MerchantRemoteResponse<"ACCOUNT_CREDIT_REVERSE_FAILURE", any>;
export type AccountCreditReverseActionRequest =
  remoteAction.MerchantRemoteResponse<"ACCOUNT_CREDIT_REVERSE_REQUEST", any>;

export interface AccountCreditReverseAction
  extends remoteAction.PostRemoteRequest {
  types: {
    request: "ACCOUNT_CREDIT_REVERSE_REQUEST";
    success: "ACCOUNT_CREDIT_REVERSE_SUCCESS";
    failure: "ACCOUNT_CREDIT_REVERSE_FAILURE";
  };
}

export interface AccountCreditReverseParams {
  transactionId: string;
}

export const accountCreditReverse = ({
  transactionId,
}: AccountCreditReverseParams): AccountCreditReverseAction => ({
  type: "MERCHANT_REMOTE_REQUEST",
  types: {
    request: "ACCOUNT_CREDIT_REVERSE_REQUEST",
    failure: "ACCOUNT_CREDIT_REVERSE_FAILURE",
    success: "ACCOUNT_CREDIT_REVERSE_SUCCESS",
  },
  method: "POST",
  https: true,
  data: { transactionId },
  url: `/rewards/reverse`,
});
